function objectToFormData(obj) {
  const data = new FormData();

  for (const [k, v] of Object.entries(obj)) {
    if (v === null) {
      data.append(k, "");
    } else if (v === undefined) {
      data.append(k, "");
    } else if (Array.isArray(v)) {
      if (v.length) {
        for (const vv of v) {
          data.append(k, vv);
        }
      } else {
        data.append(k, "");
      }
    } else {
      data.append(k, v);
    }
  }

  return data;
}

function parseApiError(error, i18n) {
  if (error.response) {
    if (error.response.status === 401) {
      return i18n.t("login.field");
    } else if (error.response.status === 403) {
      return error.response.statusText;
    } else if (error.response.status === 404) {
      return i18n.t("not.found");
    } else if (error.response.status === 400) {
      let data = error.response.data;
      for (let k in data) {
        switch (data[k][0]) {
          case "This field may not be blank.":
            data[k][0] = i18n.t("field.blank");
            break;
          case "This field may not be null.":
            data[k][0] = i18n.t("field.null");
            break;
          case "This field is required.":
            data[k][0] = i18n.t("field.required");
            break;
          case "You need to choose at least one model":
            data[k][0] = i18n.t("one.model");
            break;
          case "You need to choose at least one producer":
            data[k][0] = i18n.t(
                "modalblacklistadd.select-at-least-one-producer"
            );
            break;
          case "warehouse with this Name already exists.":
            data[k][0] = i18n.t("warehouse.name-exists");
            break;
          case "warehouse with this Code already exists.":
            data[k][0] = i18n.t("warehouse.code-exists");
            break;
          case "You need to choose at least one group":
            data[k][0] = i18n.t("one.group");
            break;
          case "Supplier with this registration code already exists.":
            data[k][0] = i18n.t("supplier.registration-code-exists");
            break;
          case "Supplier with this name already exists.":
            data[k][0] = i18n.t("supplier.name-exists");
            break;
          case "Supplier with this email already exists.":
            data[k][0] = i18n.t("supplier.email-exists");
            break;
          case "Start date should be earlier than finish date.":
            data[k][0] = i18n.t("tender.start-date-earlier-finish-date");
            break;
          case "Finish date should be later than start date.":
            data[k][0] = i18n.t("tender.finish-date-later-start-date");
            break;
          case "Start date should be at future.":
            data[k][0] = i18n.t("tender.start-date-should-be-at-future");
            break;
          case "Earlier than 30 minutes.":
            data[k][0] = i18n.t("tender.earlier-than-30-minutes");
            break;
          case "Finish date should be at future.":
            data[k][0] = i18n.t("tender.finish-date-should-be-at-future");
            break;
          case "It should be at least one qty":
            data[k][0] = i18n.t("detail.empty-qty");
            break;
          case "Agree field is required.":
            data[k][0] = i18n.t("register.validation.agree")
            break;
          case "Name cannot begin or end with a symbol.":
            data[k][0] = i18n.t("message-errors.begin-end-symbol");
            break;
          case "Name can't be numeric.":
            data[k][0] = i18n.t("message-errors.disallow-numeric");
            break;
          case "Name can't include a double quotes.":
            data[k][0] = i18n.t("message-errors.disallow-double-quotes");
            break;
        }
      }
      return data;
    } else {
      return i18n.t("server.error");
    }
  } else {
    return i18n.t("network.error");
  }
}



function isValidEmail(email) {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function getFirstInvalid(obj, order = null) {
  if (order) {
    for (const v of order) {
      if (obj.hasOwnProperty(v) && obj[v]) {
        return v
      }
    }
  }
  for (const [k, v] of Object.entries(obj)) {
    if (v !== null) {
      return k
    }
  }
}

export {
  objectToFormData,
  parseApiError,
  isValidEmail,
  getFirstInvalid
};



// WEBPACK FOOTER //
// ./src/utils.js